export { default } from './clamp';